import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
export const GlobalSearchContext = /*#__PURE__*/ createContext(null);
export const useGlobalSearchContext = ()=>{
    const context = useContext(GlobalSearchContext);
    if (!context) {
        throw new Error('No data available');
    }
    return context;
};
export const GlobalSearchContextProvider = ({ children })=>{
    const [visibility, setVisibility] = useState(false);
    return /*#__PURE__*/ _jsx(GlobalSearchContext.Provider, {
        value: {
            visibility,
            setVisibility
        },
        children: children
    });
};
